import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { LEGAL_BOX_CONVERTER_TOKEN, LegalBoxConverter } from './legal-box.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        legalBoxFeature: {
          module: () => import('./legal-box.module').then((m) => m.LegalBoxModule),
          cmsComponents: ['legal_box'],
        },
      }
    }),
    {
      provide: LEGAL_BOX_CONVERTER_TOKEN,
      useExisting: LegalBoxConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        legal_box: LEGAL_BOX_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class LegalBoxFeatureModule {}
